import React,{useContext} from 'react';
import LoginContext from '../contexts/LoginContext'
const Login = () => {
    const user = useContext(LoginContext)

    return <span>{user && user.id ? "Logged In" : ""}</span>
}
export default Login;